import { createApi } from '@reduxjs/toolkit/query/react';
import { configBaseQuery } from '../config';
import { GetCrmTenantsResponse, SyncCrmTenantsData, SyncCrmTenantsResponse } from './types';

export const crmTenantsApi = createApi({
  reducerPath: 'crmTenantsApi',
  tagTypes: ['CrmTenants'],
  baseQuery: configBaseQuery,
  refetchOnMountOrArgChange: 60,
  endpoints: (build) => ({
    getCrmTenants: build.query<GetCrmTenantsResponse, void>({
      query: () => '/api/crm-tenants',
      providesTags: ['CrmTenants']
    }),
    syncCrmTenants: build.mutation<SyncCrmTenantsResponse, SyncCrmTenantsData>({
      query: (body) => ({
        url: '/api/crm-tenants/sync',
        method: 'POST',
        body
      }),
      invalidatesTags: ['CrmTenants']
    })
  })
});
